import GuestHeader from './GuestHeader';
export default GuestHeader;
